var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDice = function SvgIconDice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M11.676 10.616a2.29 2.29 0 0 0-2.292-2.292H3.551a2.291 2.291 0 0 0-2.292 2.292v5.833a2.294 2.294 0 0 0 2.292 2.292h5.833a2.292 2.292 0 0 0 2.292-2.292v-5.833Zm-2.292 5a.834.834 0 1 0-1.667 0 .834.834 0 0 0 1.667 0Zm-5-.834a.834.834 0 1 0 0 1.668.834.834 0 0 0 0-1.668ZM6.467 12.7a.834.834 0 1 0 .001 1.667.834.834 0 0 0 0-1.667Zm2.084-2.083a.834.834 0 1 0 0 1.667.834.834 0 0 0 0-1.667Zm-3.333.833a.834.834 0 1 0-1.668 0 .834.834 0 0 0 1.668 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M7.107 7.49h2.277c.829 0 1.623.33 2.21.917.586.585.915 1.38.915 2.209v2.16c.687.232 1.16.384 1.19.395a2.293 2.293 0 0 0 2.931-1.38l1.976-5.49a2.289 2.289 0 0 0-1.381-2.931l-5.488-1.976a2.29 2.29 0 0 0-2.933 1.38L7.107 7.492Zm7.649 2.74a.834.834 0 1 0-1.57-.564.834.834 0 0 0 1.57.565Zm-1.757-3.732a.833.833 0 1 0-.563 1.569.833.833 0 0 0 .563-1.569ZM12.247 4.9a.834.834 0 1 0-1.57-.564.834.834 0 0 0 1.57.564Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconDice;